import { jsx } from "react/jsx-runtime";
import OrganizationLogoImage from "./components/OrganizationLogoImage.js";
const Logo = ({ organizationSlug, role })=>{
    const handleLogoClick = ()=>{
        if ('admin' === role) window.location.href = `/org/${organizationSlug}/panel/`;
        else if ('user' === role) window.location.href = `/org/${organizationSlug}/home/`;
    };
    return /*#__PURE__*/ jsx("button", {
        type: "button",
        id: "main-menu-logo",
        className: "tw-hidden sm:tw-flex tw-items-center tw-w-[25.6rem] -tw-ml-[6.3rem] tw-justify-center tw-flex-shrink-0  tw-mr-auto",
        disabled: !role,
        onClick: handleLogoClick,
        children: /*#__PURE__*/ jsx(OrganizationLogoImage, {
            alt: organizationSlug
        })
    });
};
const Logo_Logo = Logo;
export default Logo_Logo;
